import { WrapperContent } from "../../components/WrapperContent";

export default function Home() {
  return (
    <WrapperContent>
      <h1>Hello World!</h1>
    </WrapperContent>
  );
}
